/* import __COLOCATED_TEMPLATE__ from './market-textarea-with-counter.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/**
## MarketTextareaWithCounter

This component builds simply atop market-textarea to add a counter for the length of the current input,
and a comparison against the maximum allowed input so users know how close they are to the limit.

NOTE: we hope to add this functionality into the web component for market-textarea https://block.atlassian.net/browse/AP-24690

### Parameters
All attributes are spread onto the internal `market-textarea`, so this component supports the props defined below as well as
those supported by market-textarea https://market-storybook.s3.amazonaws.com/index.html?path=/docs/form-fields-market-textarea--basic-example

@param {number} initialLength - Optional/Required - initial length to render for counter, required if passing an initial `value` attribute (cannot enforce as no access to attrs)
@param {number} maximumLength - Optional - maximum length for textarea, overrides existing maxlength attr and displays counter with comparison against maximum (e.g. 'current / maximum')
*/

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let MarketTextareaWithCounter = (_class = class MarketTextareaWithCounter extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "currentCharacterCount", _descriptor, this);
    if (this.args.initialLength) {
      this.currentCharacterCount = this.args.initialLength;
    }
  }
  updateCharacterCount(event) {
    if (event.target.value?.length >= 0) {
      this.currentCharacterCount = event.target.value.length;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentCharacterCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateCharacterCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCharacterCount"), _class.prototype), _class);
export { MarketTextareaWithCounter as default };